import {jobsData} from './job_interface';

export const COUNTRIES: jobsData[] = [
  {
    "id": 372,
    "BotId": 10,
    "ParentId": 9,
    "Bot_orgId": "10_225",
    "orgId": 225,
    "BotName": "Prompt.atmx",
    "BotPermission": {
        "run": true,
        "delete": true,
        "upload": true,
        "execute": true,
        "download": true
    },
    "LastModified": "2019-07-26T11:15:37.000Z",
    "BotPath": "Automation Anywhere\\My Tasks\\Sample Tasks\\Prompt.atmx",
    "Directory": 0
},
{
    "id": 373,
    "BotId": 11,
    "ParentId": 9,
    "Bot_orgId": "11_225",
    "orgId": 225,
    "BotName": "Files-Folders.atmx",
    "BotPermission": {
        "run": true,
        "delete": true,
        "upload": true,
        "execute": true,
        "download": true
    },
    "LastModified": "2019-08-09T21:03:36.000Z",
    "BotPath": "Automation Anywhere\\My Tasks\\Sample Tasks\\Files-Folders.atmx",
    "Directory": 0
},
{
    "id": 374,
    "BotId": 12,
    "ParentId": 9,
    "Bot_orgId": "12_225",
    "orgId": 225,
    "BotName": "Variables.atmx",
    "BotPermission": {
        "run": true,
        "delete": true,
        "upload": true,
        "execute": true,
        "download": true
    },
    "LastModified": "2019-11-18T06:48:18.000Z",
    "BotPath": "Automation Anywhere\\My Tasks\\Sample Tasks\\Variables.atmx",
    "Directory": 0
},
{
    "id": 375,
    "BotId": 13,
    "ParentId": 9,
    "Bot_orgId": "13_225",
    "orgId": 225,
    "BotName": "Prompt_01.atmx",
    "BotPermission": {
        "run": true,
        "delete": true,
        "upload": true,
        "execute": true,
        "download": true
    },
    "LastModified": "2019-11-19T13:08:19.000Z",
    "BotPath": "Automation Anywhere\\My Tasks\\Sample Tasks\\Prompt_01.atmx",
    "Directory": 0
},
{
    "id": 376,
    "BotId": 14,
    "ParentId": 9,
    "Bot_orgId": "14_225",
    "orgId": 225,
    "BotName": "Prompt_02.atmx",
    "BotPermission": {
        "run": true,
        "delete": true,
        "upload": true,
        "execute": true,
        "download": true
    },
    "LastModified": "2019-11-19T13:08:29.000Z",
    "BotPath": "Automation Anywhere\\My Tasks\\Sample Tasks\\Prompt_02.atmx",
    "Directory": 0
},
{
    "id": 377,
    "BotId": 15,
    "ParentId": 9,
    "Bot_orgId": "15_225",
    "orgId": 225,
    "BotName": "Prompt_03.atmx",
    "BotPermission": {
        "run": true,
        "delete": true,
        "upload": true,
        "execute": true,
        "download": true
    },
    "LastModified": "2019-11-19T13:08:38.000Z",
    "BotPath": "Automation Anywhere\\My Tasks\\Sample Tasks\\Prompt_03.atmx",
    "Directory": 0
},
{
    "id": 378,
    "BotId": 16,
    "ParentId": 9,
    "Bot_orgId": "16_225",
    "orgId": 225,
    "BotName": "Prompt_04.atmx",
    "BotPermission": {
        "run": true,
        "delete": true,
        "upload": true,
        "execute": true,
        "download": true
    },
    "LastModified": "2019-11-19T13:08:48.000Z",
    "BotPath": "Automation Anywhere\\My Tasks\\Sample Tasks\\Prompt_04.atmx",
    "Directory": 0
},
{
    "id": 379,
    "BotId": 17,
    "ParentId": 9,
    "Bot_orgId": "17_225",
    "orgId": 225,
    "BotName": "Prompt_05.atmx",
    "BotPermission": {
        "run": true,
        "delete": true,
        "upload": true,
        "execute": true,
        "download": true
    },
    "LastModified": "2019-11-19T13:08:56.000Z",
    "BotPath": "Automation Anywhere\\My Tasks\\Sample Tasks\\Prompt_05.atmx",
    "Directory": 0
},
{
    "id": 380,
    "BotId": 18,
    "ParentId": 9,
    "Bot_orgId": "18_225",
    "orgId": 225,
    "BotName": "Prompt_06.atmx",
    "BotPermission": {
        "run": true,
        "delete": true,
        "upload": true,
        "execute": true,
        "download": true
    },
    "LastModified": "2019-11-19T13:09:29.000Z",
    "BotPath": "Automation Anywhere\\My Tasks\\Sample Tasks\\Prompt_06.atmx",
    "Directory": 0
},
{
    "id": 381,
    "BotId": 19,
    "ParentId": 9,
    "Bot_orgId": "19_225",
    "orgId": 225,
    "BotName": "Prompt_07.atmx",
    "BotPermission": {
        "run": true,
        "delete": true,
        "upload": true,
        "execute": true,
        "download": true
    },
    "LastModified": "2019-11-19T13:09:40.000Z",
    "BotPath": "Automation Anywhere\\My Tasks\\Sample Tasks\\Prompt_07.atmx",
    "Directory": 0
},
{
    "id": 382,
    "BotId": 20,
    "ParentId": 9,
    "Bot_orgId": "20_225",
    "orgId": 225,
    "BotName": "Prompt_08.atmx",
    "BotPermission": {
        "run": true,
        "delete": true,
        "upload": true,
        "execute": true,
        "download": true
    },
    "LastModified": "2019-11-19T13:09:48.000Z",
    "BotPath": "Automation Anywhere\\My Tasks\\Sample Tasks\\Prompt_08.atmx",
    "Directory": 0
},
{
    "id": 383,
    "BotId": 21,
    "ParentId": 9,
    "Bot_orgId": "21_225",
    "orgId": 225,
    "BotName": "Prompt_09.atmx",
    "BotPermission": {
        "run": true,
        "delete": true,
        "upload": true,
        "execute": true,
        "download": true
    },
    "LastModified": "2019-11-19T13:09:57.000Z",
    "BotPath": "Automation Anywhere\\My Tasks\\Sample Tasks\\Prompt_09.atmx",
    "Directory": 0
},
{
    "id": 384,
    "BotId": 22,
    "ParentId": 9,
    "Bot_orgId": "22_225",
    "orgId": 225,
    "BotName": "Prompt_10.atmx",
    "BotPermission": {
        "run": true,
        "delete": true,
        "upload": true,
        "execute": true,
        "download": true
    },
    "LastModified": "2019-11-19T13:10:05.000Z",
    "BotPath": "Automation Anywhere\\My Tasks\\Sample Tasks\\Prompt_10.atmx",
    "Directory": 0
},
{
    "id": 385,
    "BotId": 23,
    "ParentId": 9,
    "Bot_orgId": "23_225",
    "orgId": 225,
    "BotName": "Variables_01.atmx",
    "BotPermission": {
        "run": true,
        "delete": true,
        "upload": true,
        "execute": true,
        "download": true
    },
    "LastModified": "2019-11-19T13:10:14.000Z",
    "BotPath": "Automation Anywhere\\My Tasks\\Sample Tasks\\Variables_01.atmx",
    "Directory": 0
},
{
    "id": 386,
    "BotId": 24,
    "ParentId": 9,
    "Bot_orgId": "24_225",
    "orgId": 225,
    "BotName": "Variables_02.atmx",
    "BotPermission": {
        "run": true,
        "delete": true,
        "upload": true,
        "execute": true,
        "download": true
    },
    "LastModified": "2019-11-19T13:10:23.000Z",
    "BotPath": "Automation Anywhere\\My Tasks\\Sample Tasks\\Variables_02.atmx",
    "Directory": 0
},
{
    "id": 387,
    "BotId": 25,
    "ParentId": 9,
    "Bot_orgId": "25_225",
    "orgId": 225,
    "BotName": "Variables_03.atmx",
    "BotPermission": {
        "run": true,
        "delete": true,
        "upload": true,
        "execute": true,
        "download": true
    },
    "LastModified": "2019-11-19T13:10:34.000Z",
    "BotPath": "Automation Anywhere\\My Tasks\\Sample Tasks\\Variables_03.atmx",
    "Directory": 0
},
{
    "id": 388,
    "BotId": 26,
    "ParentId": 9,
    "Bot_orgId": "26_225",
    "orgId": 225,
    "BotName": "Variables_04.atmx",
    "BotPermission": {
        "run": true,
        "delete": true,
        "upload": true,
        "execute": true,
        "download": true
    },
    "LastModified": "2019-11-19T13:10:44.000Z",
    "BotPath": "Automation Anywhere\\My Tasks\\Sample Tasks\\Variables_04.atmx",
    "Directory": 0
},
{
    "id": 389,
    "BotId": 27,
    "ParentId": 9,
    "Bot_orgId": "27_225",
    "orgId": 225,
    "BotName": "Variables_05.atmx",
    "BotPermission": {
        "run": true,
        "delete": true,
        "upload": true,
        "execute": true,
        "download": true
    },
    "LastModified": "2019-11-19T13:10:51.000Z",
    "BotPath": "Automation Anywhere\\My Tasks\\Sample Tasks\\Variables_05.atmx",
    "Directory": 0
},
{
    "id": 390,
    "BotId": 28,
    "ParentId": 9,
    "Bot_orgId": "28_225",
    "orgId": 225,
    "BotName": "Variables_06.atmx",
    "BotPermission": {
        "run": true,
        "delete": true,
        "upload": true,
        "execute": true,
        "download": true
    },
    "LastModified": "2019-11-19T13:11:01.000Z",
    "BotPath": "Automation Anywhere\\My Tasks\\Sample Tasks\\Variables_06.atmx",
    "Directory": 0
},
{
    "id": 391,
    "BotId": 29,
    "ParentId": 9,
    "Bot_orgId": "29_225",
    "orgId": 225,
    "BotName": "Variables_07.atmx",
    "BotPermission": {
        "run": true,
        "delete": true,
        "upload": true,
        "execute": true,
        "download": true
    },
    "LastModified": "2019-11-19T13:11:13.000Z",
    "BotPath": "Automation Anywhere\\My Tasks\\Sample Tasks\\Variables_07.atmx",
    "Directory": 0
},
{
    "id": 392,
    "BotId": 30,
    "ParentId": 9,
    "Bot_orgId": "30_225",
    "orgId": 225,
    "BotName": "Variables_08.atmx",
    "BotPermission": {
        "run": true,
        "delete": true,
        "upload": true,
        "execute": true,
        "download": true
    },
    "LastModified": "2019-11-19T13:11:24.000Z",
    "BotPath": "Automation Anywhere\\My Tasks\\Sample Tasks\\Variables_08.atmx",
    "Directory": 0
},
{
    "id": 393,
    "BotId": 31,
    "ParentId": 9,
    "Bot_orgId": "31_225",
    "orgId": 225,
    "BotName": "Variables_09.atmx",
    "BotPermission": {
        "run": true,
        "delete": true,
        "upload": true,
        "execute": true,
        "download": true
    },
    "LastModified": "2019-11-19T13:11:41.000Z",
    "BotPath": "Automation Anywhere\\My Tasks\\Sample Tasks\\Variables_09.atmx",
    "Directory": 0
},
{
    "id": 394,
    "BotId": 32,
    "ParentId": 9,
    "Bot_orgId": "32_225",
    "orgId": 225,
    "BotName": "Variables_10.atmx",
    "BotPermission": {
        "run": true,
        "delete": true,
        "upload": true,
        "execute": true,
        "download": true
    },
    "LastModified": "2019-11-19T13:11:49.000Z",
    "BotPath": "Automation Anywhere\\My Tasks\\Sample Tasks\\Variables_10.atmx",
    "Directory": 0
}
  
];
